/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts
 🗓️ Created: 2025-01-15
 🧩 Description:
    Default form data factories for Conferences module.
────────────────────────────────────────────────────────────────*/

import type { ConferenceRoom } from '../types';
import { DEFAULT_LANGUAGE, DEFAULT_TIMEZONE } from '../../../data/formOptions';

/**
 * Creates default conference form data
 */
export function createDefaultConferenceData(): ConferenceRoom {
  return {
    // General Information
    extension: '',
    name: '',
    description: '',
    enabled: true,
    language: DEFAULT_LANGUAGE,
    timezone: DEFAULT_TIMEZONE,
    moderatorPin: '',
    participantPin: '',
    profile_id: 1,

    // Behavior Controls
    maxMembers: 0,
    announceName: false,
    announceCount: false,
    waitForModerator: false,
    muteOnEntry: false,
    deafOnEntry: false,
    endConfOnModExit: 0,
    skipEmptyConference: false,
    lockConference: false,

    // Audio Settings
    mohSound: 'default',
    enterSound: 'tone_stream://%(200,0,1000)',
    exitSound: 'tone_stream://%(200,0,400)',
    energyLevel: 300,
    callerControlsProfile: 'default',
    conferenceFlags: 'mintwo,moderator',
    comfortNoise: true,
    autoGainControl: false,

    // Recording Options
    recordIncoming: false,
    recordOutgoing: false,
    recordOnDemand: false,
    recordFileFormat: 'wav',
    recordPath: '/recordings',
    recordFilenameTemplate: '',
    recordModeratorOnly: false,

    // Video Behavior
    videoMode: 'auto',
    videoLayout: '1x1',
    videoCodec: 'VP8',
    maxVideoParticipants: 9,
    videoResolution: '720p',
    recordVideo: false,

    // Presence & Integration (Advanced)
    presenceId: '',
    announceNewModerator: false,
    apiControlViaEventSocket: false,
    databaseLogging: false,
    dtmfMenuKey: '*',
    moderatorControls: true,
  };
}

